module.exports = __webpack_public_path__ + "static/img/102-text.2e1f270.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/102-text.png
// module id = Jv96
// module chunks = 12